import { SessionService } from '../Session/SessionService';
import { Config, ConfigServiceInterface } from './types/ConfigTypes';

/**
 * * ConfigService
 * @description Service to set and get configurations
 *
 * * @function getConfigs
 *   @returns Object with configurations
 *   @description to get environment configurations
 * * @function setConfigs
 *   @param Configs
 *   @type Object
 *   @description: to set configurations data
 */
const ConfigService: ConfigServiceInterface = (function (root, factory) {
  let ConfigService: ConfigServiceInterface = {} as ConfigServiceInterface;
  if (root) {
    // If instance exists use it otherwise create new.
    if (root.ConfigService) {
      ({ ConfigService } = root);
    } else {
      root.ConfigService = ConfigService;
      return factory(ConfigService);
    }
  }

  return ConfigService;
})(
  (typeof window === 'object' && window) || (typeof globalThis === 'object' && globalThis) || this,
  function (ConfigService: ConfigServiceInterface) {
    let configProxy: Config = {};

    const getConfigs = (country?: string) => {
      const { session } = SessionService.getSession();
      let countryConfigs = { ...configProxy };
      const resolvedCountry = country ?? session.currentCountry;
      if (resolvedCountry) {
        countryConfigs = {
          ...countryConfigs,
          ...(configProxy[resolvedCountry] as Config),
        };
      }
      return countryConfigs;
    };

    const setConfigs = (configs: Config) => {
      configProxy = Object.assign(configProxy, configs);
    };

    // Adding methods to Instance.
    ConfigService.getConfigs = getConfigs;
    ConfigService.setConfigs = setConfigs;

    return ConfigService;
  },
);

export { ConfigService };
export type { Config };
